var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "margin-top-50" }),
                _vm._v(" "),
                _c("div", { staticClass: "header-wrapper" }, [
                  _c("h1", {
                    staticClass: "text-primary-fh left-header",
                    domProps: {
                      innerHTML: _vm._s(_vm.data.familytree.sendinviteHeader)
                    }
                  })
                ]),
                _vm._v(" "),
                _c("p", {
                  staticClass: "text-dark",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.data.familytree.sendinviteDisclaimerText
                    )
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-md-6" },
                [
                  _vm._l(_vm.selectedRelatives, function(sr, i) {
                    return _c("div", { key: i }, [
                      _c("div", { staticClass: "card" }, [
                        _c("div", { staticClass: "card-body text-left" }, [
                          _c("h6", {
                            staticClass: "card-title text-primary-fh",
                            domProps: {
                              textContent: _vm._s(
                                sr.firstName + " " + sr.lastName
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "h6",
                            {
                              staticClass: "text-dark cursor-pointer",
                              attrs: {
                                "data-toggle": "collapse",
                                "data-target": "#card-" + i
                              }
                            },
                            [
                              _vm._v(
                                "\n                Kontaktsätt\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "collapse",
                              attrs: { id: "card-" + i }
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: sr.emailAddress,
                                    expression: "sr.emailAddress"
                                  }
                                ],
                                staticClass: "form-control form-control-lg",
                                class:
                                  sr.emailAddress &&
                                  sr.emailAddress.length > 0 &&
                                  !_vm.validEmail(sr.emailAddress)
                                    ? "invalid"
                                    : "",
                                attrs: {
                                  type: "text",
                                  step: "1",
                                  min: "1",
                                  max: "200",
                                  placeholder: "E-post"
                                },
                                domProps: { value: sr.emailAddress },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      sr,
                                      "emailAddress",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "margin-6" }),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: sr.phoneNumber,
                                    expression: "sr.phoneNumber"
                                  }
                                ],
                                staticClass: "form-control form-control-lg",
                                attrs: {
                                  type: "number",
                                  maxlength: "10",
                                  oninput:
                                    "this.value=this.value.slice(0,this.maxLength)",
                                  placeholder: "SMS"
                                },
                                domProps: { value: sr.phoneNumber },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      sr,
                                      "phoneNumber",
                                      $event.target.value
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("small", [
                                _vm._v(
                                  "Ange e-postadress och/eller telefonnummer för SMS"
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" })
                        ])
                      ])
                    ])
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body text-left" }, [
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("h6", { staticClass: "text-dark" }, [
                        _vm._v("Förhandsvisning av meddelandet:")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "card override-card" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-body override-card-body text-left"
                          },
                          [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.familytree.topPreviewText.replace(
                                    "{fullName}",
                                    _vm.fullname + ":"
                                  )
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                textContent: _vm._s(_vm.personalMessage)
                              }
                            }),
                            _vm._v(" "),
                            _vm.personalMessage.length < 1
                              ? _c("p", [
                                  _c("i", { staticClass: "text-muted" }, [
                                    _vm._v("Ditt personliga meddelande..")
                                  ])
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.familytree.bottomPreviewText.replace(
                                    "{invitationLink}",
                                    "[Länk kommer här]"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      ])
                    ])
                  ])
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-lg btn-block",
                    attrs: { disabled: _vm.dirty },
                    on: {
                      click: function($event) {
                        return _vm.sendInvites()
                      }
                    }
                  },
                  [_vm._v("\n          Skicka inbjudningsmeddelande\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-dark btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("← Tillbaka")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c("small", [
                  _vm._v(
                    "Fyll i e-postadress eller telefonnummer för att skicka meddelandet."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-12e6fa23", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12e6fa23","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FamilyTreeSendInvite.vue
// module id = null
// module chunks = 